export const SETTINGS_BASE_PATH = '/settings-hub';

export type SettingsTabDef = {
  label: string;
  path: string;
  breadcrumbLabel: string;
  restricted?: boolean;
};

export const SETTINGS_TABS: SettingsTabDef[] = [
  { label: 'ACCOUNT', path: 'account', breadcrumbLabel: 'Account Settings' },
  {
    label: 'NOTIFICATIONS',
    path: 'notifications',
    breadcrumbLabel: 'Notification Settings',
    restricted: true
  },
  {
    label: 'ISSUE CONFIGURATION',
    path: 'issue-configuration',
    breadcrumbLabel: 'Issue Configuration',
    restricted: true
  },
  {
    label: 'MAINTENANCE',
    path: 'maintenance',
    breadcrumbLabel: 'Maintenance Settings',
    restricted: true
  }
  // {
  //   label: 'INSPECTION',
  //   path: 'inspection',
  //   breadcrumbLabel: 'Inspection Settings',
  //   restricted: true
  // },
  // {
  //   label: 'LIVE MONITORING',
  //   path: 'live-monitoring',
  //   breadcrumbLabel: 'Live Monitoring Settings',
  //   restricted: true
  // }
];

export type SettingsAreaDef = SettingsTabDef & {
  description: string;
};

export const SETTINGS_AREAS: SettingsAreaDef[] = [
  {
    ...SETTINGS_TABS[0],
    description: 'Change password and manage organization logo.'
  },
  {
    ...SETTINGS_TABS[1],
    description: 'Configure notification channels, recipients, schedules and reminders.'
  },
  {
    ...SETTINGS_TABS[2],
    description:
      'Configure issue colours, due-date thresholds, criticality and issue notifications.'
  },
  {
    ...SETTINGS_TABS[3],
    description: 'Manage maintenance trigger types, defaults and scheduling rules.'
  }
  // {
  //   ...SETTINGS_TABS[4],
  //   description: 'Configure inspection defaults, frequencies, assignments and report settings.'
  // },
  // {
  //   ...SETTINGS_TABS[5],
  //   description: 'Configure sensor connectivity, thresholds, data frequency and alert behaviour.'
  // }
];
